import { MessageCircle, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/lib/site";

/**
 * Product-specific WhatsApp quote button.
 * Pre-fills the WhatsApp chat with a structured inquiry referencing the current product.
 */
export default function WhatsAppQuoteButton({ product, className = "", testId = "whatsapp-quote-btn" }) {
  const productName = product?.name || "your product range";
  const series = product?.series || "";
  const message = `Hello STENZIA Displays,

I am interested in the product:
${productName}${series ? `\n(${series})` : ""}

Please share pricing, specifications and delivery details.`;

  const url = `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`group inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#25D366] text-white text-sm font-medium hover:bg-[#1B8C4A] transition-colors shadow-[0_8px_20px_-10px_rgba(37,211,102,0.55)] ${className}`}
    >
      <MessageCircle size={15} fill="currentColor" />
      Get Quote on WhatsApp
      <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </a>
  );
}
